import { LegalPage } from '../components/LegalPage';
import { SP_EMAIL } from '../lib/brand';

const SECTIONS = [
  { h: '1. Acceptance of Terms', p: 'By using Trade PMI you agree to these Terms. If you do not agree, do not use the platform.' },
  {
    h: '2. Service Description',
    p: 'Trade PMI by Standards Protocol is a free, publicly available tool that describes observable market conditions:',
    list: ['Five-engine ticker assessment (energy, pressure, position, momentum, environment)', 'Market overview and multi-ticker intelligence table', 'Position risk, volatility range and conditions checklist tools'],
  },
  {
    h: '3. Important Disclaimer',
    warn: true,
    p: 'Trade PMI does not provide financial advice. All outputs are descriptive and for general information only. They are not recommendations, forecasts or offers to buy or sell any financial product.',
    list: ['Past behaviour does not indicate future results', 'All investing involves risk of loss', 'Consider seeking advice from a licensed financial adviser before making decisions', 'Standards Protocol is not liable for losses arising from use of the platform'],
  },
  { h: '4. Data Sources', p: 'Market data comes from Yahoo Finance (yfinance) and may be delayed, cached for up to 10 minutes, incomplete or inaccurate. We do not guarantee its accuracy or timeliness.' },
  { h: '5. Acceptable Use', list: ['Do not use the platform for any unlawful purpose', 'Do not scrape, overload or interfere with the service', 'Do not attempt to reverse engineer the engines'] },
  { h: '6. Limitation of Liability', p: 'To the maximum extent permitted by law, Standards Protocol is not liable for any indirect, incidental, special or consequential loss arising from your use of the platform.' },
  { h: '7. Changes', p: 'We may update these Terms at any time. Continued use after changes means you accept the updated Terms.' },
  { h: '8. Governing Law', p: 'These Terms are governed by the laws of Australia.' },
  { h: '9. Contact', p: `Questions about these Terms, tailored solutions or business enquiries: ${SP_EMAIL}.` },
];

export default function Terms() {
  return <LegalPage title="Terms of Service" sections={SECTIONS} testId="terms-title" />;
}
